//************************************************************************ /
// SHARE STORY CTA CARD
// Used on event detail.tsx view. If there are stories, this is the first
// card that is displayed, encouraging users to upload more stories.
//************************************************************************ /

import React from "react";
import {
  Card,
  Button,
  Group,
  Typography,
} from "@dreambigger/design-system/src/components";
import { Event as EventType } from "@dreambigger/shared/src/types";

const { Title, Text } = Typography;

type ShareStoryCtaCardProps = {
  event: EventType;
};

const handleClick = () => {
  window.location.pathname = window.location.pathname.replace("detail", "share");
};

const ShareStoryCtaCard = ({ event }: ShareStoryCtaCardProps) => {
  return (
    <Card className={`lift bg-cta`} style={{ background: "black" }}>
      <Group className="items-center tc">
        {/* Call To Action Text */}
        <Title level={4} className="textSecondary lh-3 mb-3">
          Share Your Experience!
        </Title>
        <Text className="textSecondary lh-2 mb-5">
          Join with others by sharing a photo or story from the event.
        </Text>
        {/* Button Link */}
        <Button type="primary" className={`f-2 mb-3`} onClick={handleClick}>
          SHARE A PHOTO
        </Button>
        <Text className="mb-0 textSecondary hlight-primary fwb f-2 pointer">
          OR COMMENT
        </Text>
      </Group>
    </Card>
  );
};

export default ShareStoryCtaCard;
